import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { initials } from '../../utils/helpers';
import { adminApi } from '../../api/client';
import { useApi } from '../../hooks/useApi';

export const Sidebar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  // Badge dynamique : cumule les demandes en attente (entreprise v2.2 + comptes app)
  const { data: pendingAccounts } = useApi(() => adminApi.getPendingValidations());
  const { data: enterpriseReqs  } = useApi(() => adminApi.getEnterpriseRequests({ status: 'pending' }));
  const { data: supportStats    } = useApi(() => adminApi.getSupportStats());
  const { data: serviceReqs     } = useApi(() => adminApi.getServiceRequests({ status: 'pending' }));
  const { data: activeCoursesRaw} = useApi(() => adminApi.getActiveCourses());

  const validationBadge = (pendingAccounts?.data?.length || 0) + (enterpriseReqs?.data?.length || 0);
  const supportBadge    = supportStats?.data?.open || 0;
  const servicesBadge   = serviceReqs?.data?.length || 0;
  const coursesBadge    = activeCoursesRaw?.data?.length || 0;

  const handleLogout = async () => {
    await logout();
    navigate('/login', { replace: true });
  };

  const NAV_GROUPS = [
    {
      section: 'Principal',
      items: [
        { to: '/',            label: 'Tableau de bord',    icon: '📊' },
        { to: '/validations', label: 'Validations',        icon: '✅', badge: validationBadge || null },
        { to: '/commandes',   label: 'Commandes',          icon: '📦' },
        { to: '/courses',     label: 'Courses',             icon: '🚗', badge: coursesBadge || null },
        { to: '/support',     label: 'Support',             icon: '🎫', badge: supportBadge || null },
      ],
    },
    {
      section: 'Gestion',
      items: [
        { to: '/laveries', label: 'Laveries',        icon: '🏪' },
        { to: '/livreurs', label: 'Livreurs',         icon: '🛵' },
        { to: '/clients',  label: 'Clients',          icon: '👥' },
        { to: '/promos',   label: 'Codes promo',      icon: '🎁' },
        { to: '/services', label: 'Services & Prix',  icon: '🔧', badge: servicesBadge || null },
      ],
    },
    {
      section: 'Compte',
      items: [
        { to: '/parametres', label: 'Paramètres', icon: '⚙️' },
      ],
    },
  ];

  return (
    <aside className="sidebar">
      <div className="sidebar-logo">
        <div className="logo-mark">
          <span className="logo-accent">LAV</span>EX
          <span className="logo-tag">ADMIN</span>
        </div>
        <div style={{ fontSize: 11, color: 'var(--text3)', marginTop: 4 }}>Plateforme d'administration</div>
      </div>

      <nav className="sidebar-nav">
        {NAV_GROUPS.map(group => (
          <div key={group.section} className="nav-section">
            <div className="nav-section-label">{group.section}</div>
            {group.items.map(item => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === '/'}
                className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
              >
                <span className="nav-icon">{item.icon}</span>
                <span className="nav-label">{item.label}</span>
                {item.badge > 0 && (
                  <span className="nav-badge" style={{
                    background: item.to === '/support'
                      ? 'var(--blue)'
                      : item.to === '/services'
                        ? 'var(--orange)'
                        : item.to === '/courses'
                          ? 'var(--accent)'
                          : 'var(--red)',
                  }}>
                    {item.badge > 99 ? '99+' : item.badge}
                  </span>
                )}
              </NavLink>
            ))}
          </div>
        ))}
      </nav>

      <div className="sidebar-footer">
        <div className="user-pill">
          <div className="user-pill-avatar">{initials(user?.name)}</div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div className="user-pill-name" style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
              {user?.name}
            </div>
            <div className="user-pill-role">Administrateur</div>
          </div>
        </div>
        <button
          className="btn btn-ghost btn-sm btn-full"
          style={{ fontSize: 12, justifyContent: 'flex-start', gap: 8 }}
          onClick={handleLogout}
        >
          <span>→</span> Déconnexion
        </button>
      </div>
    </aside>
  );
};